import React, { Component } from 'react';
import '../buttons.scss';
class YesButton extends Component {


    clickFunction = (type,startTime, realAnswer, automaticAnswer,timeOut, symbol, symbo2,seqtorei,quantity,total,arrangement,symbolQunatity) =>{
        if(symbol && symbo2){
            this.props.fillAnswer(type, startTime, realAnswer, automaticAnswer, timeOut, symbol, symbo2,seqtorei);
        }
        if(quantity && total && arrangement){
            this.props.fillAnswer(type, startTime, realAnswer, automaticAnswer, timeOut,quantity,total,arrangement,symbolQunatity);
        }

    }

    render() {
        const {startTime, realAnswer, automaticAnswer, timeOut,symbol,symbo2,seqtorei,quantity,total,arrangement,symbolQunatity} = {...this.props}

        if(automaticAnswer){
            this.clickFunction('No Answer', startTime, realAnswer,automaticAnswer,timeOut ,symbol, symbo2,seqtorei,quantity,total,arrangement,symbolQunatity)
        }

        return (
            <button 
                className="test-button button-Yes"
                onClick = {()=>{this.clickFunction('Yes',startTime, realAnswer, false, timeOut, symbol, symbo2,seqtorei,quantity,total,arrangement,symbolQunatity)}}
            >კი</button>
        );
    }
}

export default YesButton;